var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 140,
    viewBox: "0 0 358 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2675_39054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 358,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_2675_39054_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2675_39054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.69 75.125C197.556 75.125 165.46 124.654 149.728 149.601V249H705.263V35C529.169 35 522.247 124.401 419.11 124.401C315.973 124.401 332.858 75.125 257.69 75.125Z",
    fill: "url(#paint0_radial_2675_39054)",
    stroke: "#00B190",
    strokeWidth: 1.40789
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.189 70.5685H734.486V69.1606H131.189V70.5685ZM131.189 102.949H734.486V101.542H131.189V102.949ZM131.189 167.713H734.486V166.305H131.189V167.713ZM734.486 135.331H131.189V133.923H734.486V135.331Z",
    fill: "url(#paint1_linear_2675_39054)",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2675_39054_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2675_39054",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.765 68) rotate(43.3509) scale(263.67 429.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB190",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB190",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2675_39054",
    x1: 542.161,
    y1: 161.5,
    x2: 336.866,
    y2: -79.6213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB190",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graph-new.d229b3cbc8322f0f0bca38b7e38a7229.svg";